import React from "react";

const STATUS_MAP = {
  new: { label: "New", cls: "pill-new" },
  accepted: { label: "Accepted", cls: "pill-accepted" },
  "in-progress": { label: "In Progress", cls: "pill-in-progress" },
  completed: { label: "Completed", cls: "pill-completed" },
  "on-hold": { label: "On Hold", cls: "pill-on-hold" },
  urgent: { label: "Urgent", cls: "pill-urgent" },
  fast: { label: "Fast", cls: "pill-fast" },
  normal: { label: "Normal", cls: "pill-normal" },
  lead: { label: "Lead", cls: "pill-lead" },
  customer: { label: "Customer", cls: "pill-customer" },
  vendor: { label: "Vendor", cls: "pill-vendor" },
  contacted: { label: "Contacted", cls: "pill-contacted" },
  quoted: { label: "Quoted", cls: "pill-quoted" },
  negotiation: { label: "Negotiation", cls: "pill-negotiation" },
  won: { label: "Won", cls: "pill-won" },
  lost: { label: "Lost", cls: "pill-lost" },
  ready: { label: "Ready", cls: "pill-accepted" },
  approved: { label: "Approved", cls: "pill-accepted" },
  rejected: { label: "Rejected", cls: "pill-lost" },
  delivered: { label: "Delivered", cls: "pill-completed" },
  cancelled: { label: "Cancelled", cls: "pill-on-hold" },
  karigar_assigned: { label: "Karigar Assigned", cls: "pill-contacted" },
  staff_assigned: { label: "Staff Assigned", cls: "pill-contacted" },
  approved_ready: { label: "Approved Ready", cls: "pill-accepted" },
  rejected_ready: { label: "Rejected", cls: "pill-lost" },
};

export function StatusPill({ status, className = "", testId }) {
  if (!status) return null;
  const s = STATUS_MAP[status] || { label: status, cls: "pill-default" };
  return (
    <span className={`pill ${s.cls} ${className}`} data-testid={testId}>
      {s.label}
    </span>
  );
}
